import { useEffect, useState } from 'react';
import { formattingNumber } from '../../../Helper/utils/utils';
import {
  StyledSpecialOfferPriceButton,
  StyledSpecialOfferPrice,
} from './style';

interface IProductMadnessSpecialOfferPrice {
  price: any;
  isPreview: any;
  buttonTextColor: string;
}

export const ProductMadnessSpecialOfferPrice: React.FC<
  IProductMadnessSpecialOfferPrice
> = ({ price, isPreview = false, buttonTextColor }) => {
  const [finalPrice, setFinalPrice] = useState('');

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      !isPreview,
    );
    setFinalPrice(formattedPrice);
  }, [price]);

  return (
    <StyledSpecialOfferPriceButton>
      <StyledSpecialOfferPrice
        buttonTextColor={buttonTextColor}
        direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
      >
        <div className={'decoration'} />
        <div className={'totalPrice'}>
          <span>{price.currencySymbol}</span>
          <span>{finalPrice}</span>
        </div>
      </StyledSpecialOfferPrice>
    </StyledSpecialOfferPriceButton>
  );
};
